<template>
  <input
    v-model.number="model"
    type="number"
    class="st-control st-control--mono st-number"
    :class="{ 'st-control--shell': onShell }"
    :step="step"
    :min="min"
    :max="max"
  />
</template>

<script setup lang="ts">
const model = defineModel<number>();
defineProps<{
  step?: number | string;
  min?: number | string;
  max?: number | string;
  onShell?: boolean;
}>();
</script>

<style scoped>
.st-number {
  padding-right: var(--st-space-2);
}
</style>
